import { alpha, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { type FC, memo } from "react";
import { theme } from "../../theme/theme";

interface TimeRangeSelectorProps {
  value: number;
  onChange: (days: number) => void;
}

const TIME_RANGES = [
  { value: 30, label: "30 days" },
  { value: 60, label: "60 days" },
  { value: 90, label: "90 days" },
];

export const TimeRangeSelector: FC<TimeRangeSelectorProps> = memo(({ value, onChange }) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: number | null) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      size="small"
      sx={{
        bgcolor: "grey.100",
        borderRadius: 1.5,
        border: "none",
        p: 0.5,
        "& .MuiToggleButtonGroup-grouped": {
          border: "none",
          borderRadius: "6px !important",
          mx: 0.25,
        },
        "& .MuiToggleButton-root": {
          px: 2,
          py: 0.75,
          textTransform: "none",
          fontSize: "0.8125rem",
          fontWeight: 500,
          color: "text.secondary",
          bgcolor: "transparent",
          "&:hover": {
            bgcolor: alpha(theme.palette.text.secondary, 0.1),
          },
          "&.Mui-selected": {
            bgcolor: "common.white",
            color: "text.primary",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            "&:hover": {
              bgcolor: "common.white",
            },
          },
        },
      }}
    >
      {TIME_RANGES.map((range) => (
        <ToggleButton key={range.value} value={range.value}>
          {range.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
});

TimeRangeSelector.displayName = "TimeRangeSelector";
